import { axios } from '@/services/axios';

const getSBCsByLocation = async (locationId) => {
    const res = await axios.get(`/sessionbordercontrollers/${locationId}`);
    return res.data;
};

export default getSBCsByLocation;
